import { useTrustpilotScript } from '@moonpig/web-shared-products'
import { TRUSTPILOT_BUSINESS_UNIT_ID } from '@moonpig/web-core-brand/config'
import { useLocale } from '@moonpig/web-core-stores'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { useIsMobile } from '@moonpig/web-shared-utils'
import React, { FC, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import {
  ImpressionEvent,
  useTrackGAEventOnce,
} from '@moonpig/web-core-analytics'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Box } from '@moonpig/launchpad-components'
import {
  CONTROL_WIDGET_CONFIG,
  MICRO_STAR_WIDGET_CONFIG,
} from './trustpilotHomepageWidget'

const IMPRESSION_EVENT_DATA: ImpressionEvent = {
  event: 'impression',
  content_data: {
    content_type: 'explore | trustpilot widget | company score',
    item_id: 'trustpilot widget',
  },
  event_data: {
    category: 'explore',
    action: 'view trustpilot widget',
    label: 'trustpilot widget | company score',
    non_interaction: true,
    value: undefined,
  },
}

const StyledTrustPilotWidget = styled(Box)`
  ${s({
    p: 8,
  })}
  &:empty {
    padding: 0;
  }
`

export const CustomerSatisfaction: FC = () => {
  const locale = useLocale()
  const isMobile = useIsMobile()
  const trustpilotWidgetExperiment = useExperiment(
    'discover-trustpilot-widget-homepage',
    { fallback: 'control' },
  )
  useTrustpilotScript()

  const { trackGAEventOnce } = useTrackGAEventOnce()

  const { ref, inView } = useInView({
    triggerOnce: true,
  })

  useEffect(() => {
    if (inView) {
      trackGAEventOnce(IMPRESSION_EVENT_DATA)
    }
  }, [inView, trackGAEventOnce])

  const isDesktopVariant =
    typeof trustpilotWidgetExperiment === 'string' &&
    trustpilotWidgetExperiment.toLowerCase() === 'treatment' &&
    !isMobile
  const widgetConfig = isDesktopVariant
    ? MICRO_STAR_WIDGET_CONFIG
    : CONTROL_WIDGET_CONFIG

  return (
    <StyledTrustPilotWidget
      data-testid="trustpilot-widget"
      className="trustpilot-widget"
      ref={ref}
      data-locale={locale.language}
      data-businessunit-id={TRUSTPILOT_BUSINESS_UNIT_ID}
      {...widgetConfig}
    />
  )
}
